// Hizmet verileri — kategori bazlı.
// Saç ve gelin hizmetlerinde gerçek marka çalışma fotoğrafları kullanılır.
// Gerçek fotoğrafları olmayan hizmetlerde uygun editoryal yer tutucu görseller kullanılır;
// marka fotoğrafı eklendiğinde ilgili "image" alanı değiştirilir.

export type ServiceCategory = "sac" | "gelin" | "bakim";

export const CATEGORY_LABELS: Record<ServiceCategory, string> = {
  sac: "Saç Tasarımı",
  gelin: "Gelin & Özel Gün",
  bakim: "Güzellik & Bakım",
};

export interface TalkingPoint {
  title: string;
  text: string;
}

export interface Service {
  id: string;
  slug: string;
  name: string;
  category: ServiceCategory;
  short: string;
  imageFile: string;
  image: string;
  alt: string;
  intro: string;
  talkingPoints: TalkingPoint[];
}

export const services: Service[] = [
  // ——— SAÇ TASARIMI ———
  {
    id: "sac-kesimi",
    slug: "sac-kesimi-sekillendirme",
    name: "Saç Kesimi ve Şekillendirme",
    category: "sac",
    short: "Yüz hatlarınıza ve saç yapınıza uygun kesim seçenekleri.",
    imageFile: "GY-G1-01-sac-kesimi.jpg",
    image:
      "https://public.readdy.ai/ai/img_res/edited_4d9c0a507f51b7cc5435dbd287d0385e_be7d7f5c.jpg",
    alt: "Kesim ve şekillendirme sonrası koyu renk uzun dalgalı saç görünümü",
    intro:
      "Yüz hatlarınızı, saç yapınızı ve günlük yaşam tarzınızı birlikte değerlendirerek size en çok yakışan kesim ve şekillendirmeyi planlıyoruz.",
    talkingPoints: [
      {
        title: "Hayal ettiğiniz görünüm",
        text: "Saçınızı hangi uzunlukta, formda ve dokuda görmek istediğinizi birlikte netleştiriyoruz.",
      },
      {
        title: "Saçınızın mevcut durumu",
        text: "Saç tipiniz, yoğunluğu ve mevcut kesiminiz üzerinden size uygun seçenekleri konuşuyoruz.",
      },
      {
        title: "İçerik ve ücret",
        text: "Kesim kapsamını, şekillendirme adımlarını ve güncel ücreti salondan netleştiriyoruz.",
      },
    ],
  },
  {
    id: "sac-renklendirme",
    slug: "sac-renklendirme",
    name: "Saç Renklendirme",
    category: "sac",
    short: "Saç renginizi ve stilinizi birlikte planlayalım.",
    imageFile: "GY-G1-02-renklendirme.jpg",
    image:
      "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/64ce2725-e0d9-4798-b62a-1e39212a16d4_compressed_res11.webp",
    alt: "Balyaj ile renklendirilmiş sarı tonlu dalgalı saç görünümü",
    intro:
      "Saç renginizi ten tonunuz ve stilinizle uyumlu şekilde birlikte planlıyor, doğal ya da cesur tonlar arasında size özel bir yol çiziyoruz.",
    talkingPoints: [
      {
        title: "İstediğiniz renk ve ton",
        text: "Hedeflediğiniz rengi ve ton geçişlerini birlikte belirliyoruz.",
      },
      {
        title: "Mevcut saç renginiz ve geçmişi",
        text: "Mevcut renginiz ve daha önceki işlemleriniz üzerinden en sağlıklı yaklaşımı konuşuyoruz.",
      },
      {
        title: "Bakım süreci ve ücret",
        text: "Renklendirme kapsamını ve güncel ücret bilgisini salondan netleştiriyoruz.",
      },
    ],
  },
  {
    id: "sarisinlik-servisi",
    slug: "sarisinlik-servisi",
    name: "Sarışınlık Servisi",
    category: "sac",
    short: "Ten tonunuzla uyumlu, size özel sarışın tonları.",
    imageFile: "GY-G1-05-sarisinlik.jpg",
    // Gerçek fotoğraf eklendiğinde buraya bağlanacak.
    image:
      "https://readdy.ai/api/search-image?query=Woman%20with%20beautifully%20blended%20blonde%20balayage%20highlights%20and%20soft%20waves%2C%20warm%20honey%20and%20champagne%20tones%2C%20soft%20diffused%20light%2C%20premium%20hair%20salon%20editorial%20photography%2C%20clean%20minimal%20warm%20background%2C%20high%20detail&width=900&height=1125&seq=gulayonar-hizmet-sarisinlik&orientation=portrait",
    alt: "Sarışın tonlarla renklendirilmiş dalgalı saç görünümü",
    intro:
      "Sarışınlık servisinde ten tonunuza ve hayalinizdeki görünüme uygun tonları birlikte belirliyor, size en çok yakışan geçişleri planlıyoruz.",
    talkingPoints: [
      {
        title: "Hayalinizdeki sarışın tonu",
        text: "İstediğiniz sarışın tonunu ve açıklık seviyesini birlikte netleştiriyoruz.",
      },
      {
        title: "Mevcut saç renginiz",
        text: "Mevcut renginiz ve saçınızın durumu üzerinden en sağlıklı yaklaşımı konuşuyoruz.",
      },
      {
        title: "İçerik ve ücret",
        text: "Uygulamanın kapsamını ve güncel ücret bilgisini salondan netleştiriyoruz.",
      },
    ],
  },
  {
    id: "renkli-sac-dokunuslari",
    slug: "renkli-sac-dokunuslari",
    name: "Renkli Saç Dokunuşları",
    category: "sac",
    short: "Renkli tutamlarla kişisel stilinizi tamamlayın.",
    imageFile: "GY-G1-04-renkli-sac.jpg",
    image:
      "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/16b50f7c-b07a-4e5f-a87c-fec41589cec7_compressed_res5.webp",
    alt: "Bakır turuncu tonlu renkli saç dokunuşu görünümü",
    intro:
      "Renkli tutamlarla saçınıza kişisel bir dokunuş katıyor, stilinizi tamamlayan tonları birlikte seçiyoruz.",
    talkingPoints: [
      {
        title: "İstediğiniz renk dokunuşları",
        text: "Hangi tonlarda ve hangi bölgelerde renk dokunuşu istediğinizi birlikte belirliyoruz.",
      },
      {
        title: "Mevcut saç renginiz",
        text: "Mevcut renginizle uyumlu ya da kontrast oluşturan seçenekleri konuşuyoruz.",
      },
      {
        title: "İçerik ve ücret",
        text: "Uygulama kapsamını ve güncel ücret bilgisini salondan netleştiriyoruz.",
      },
    ],
  },
  {
    id: "yeni-nesil-perma",
    slug: "yeni-nesil-perma",
    name: "Yeni Nesil Perma",
    category: "sac",
    short: "Dalgalı ve kıvırcık saç stilleri için perma seçenekleri.",
    imageFile: "GY-G1-03-perma.jpg",
    image:
      "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/1bbc9a54-d571-467c-b936-b5f22146f88e_compressed_res7.webp",
    alt: "Yeni nesil perma ile oluşturulmuş kıvırcık saç görünümü",
    intro:
      "Dalgalı ve kıvırcık saç stilleri için saç yapınıza uygun perma seçeneklerini birlikte değerlendiriyor, istediğiniz dokuyu konuşuyoruz.",
    talkingPoints: [
      {
        title: "İstediğiniz dalga dokusu",
        text: "Ne kadar dalgalı ya da kıvırcık bir görünüm istediğinizi birlikte belirliyoruz.",
      },
      {
        title: "Saçınızın mevcut durumu",
        text: "Saç uzunluğu, yoğunluğu ve genel durumu üzerinden uygun seçenekleri konuşuyoruz.",
      },
      {
        title: "İşlem içeriği ve ücret",
        text: "Perma işleminin kapsamını ve güncel ücret bilgisini salondan netleştiriyoruz.",
      },
    ],
  },
  {
    id: "wag-masa",
    slug: "wag-masa",
    name: "Wag Maşa",
    category: "sac",
    short: "Yumuşak dalgalar ve doğal hareket için wag maşa.",
    imageFile: "GY-G1-06-wag-masa.jpg",
    // Gerçek fotoğraf eklendiğinde buraya bağlanacak.
    image:
      "https://readdy.ai/api/search-image?query=Long%20glossy%20hair%20styled%20in%20soft%20loose%20wand%20curl%20waves%20with%20natural%20movement%20and%20shine%2C%20warm%20ivory%20and%20champagne%20palette%2C%20soft%20diffused%20light%2C%20premium%20hair%20salon%20editorial%20photography%2C%20clean%20minimal%20warm%20background%2C%20high%20detail&width=900&height=1125&seq=gulayonar-hizmet-wagmasa&orientation=portrait",
    alt: "Wag maşa ile şekillendirilmiş yumuşak dalgalı saç görünümü",
    intro:
      "Wag maşa ile saçınıza yumuşak dalgalar ve doğal bir hareket katıyor, stilinize uygun dalga formunu birlikte belirliyoruz.",
    talkingPoints: [
      {
        title: "İstediğiniz dalga formu",
        text: "Ne kadar belirgin ya da yumuşak dalga istediğinizi birlikte netleştiriyoruz.",
      },
      {
        title: "Saçınızın mevcut durumu",
        text: "Saçınızın uzunluğu ve dokusu üzerinden uygun şekillendirmeyi konuşuyoruz.",
      },
      {
        title: "İçerik ve ücret",
        text: "Uygulamanın kapsamını ve güncel ücret bilgisini salondan netleştiriyoruz.",
      },
    ],
  },
  {
    id: "fon",
    slug: "fon",
    name: "Fön",
    category: "sac",
    short: "Günlük veya özel anlar için pürüzsüz, hacimli fön.",
    imageFile: "GY-G1-07-fon.jpg",
    // Gerçek fotoğraf eklendiğinde buraya bağlanacak.
    image:
      "https://readdy.ai/api/search-image?query=Freshly%20blow%20dried%20smooth%20voluminous%20hair%20with%20a%20soft%20healthy%20sheen%2C%20classic%20salon%20blowout%20look%2C%20warm%20ivory%20and%20champagne%20palette%2C%20soft%20diffused%20light%2C%20premium%20hair%20salon%20editorial%20photography%2C%20clean%20minimal%20warm%20background%2C%20high%20detail&width=900&height=1125&seq=gulayonar-hizmet-fon&orientation=portrait",
    alt: "Şekillendirilmiş pürüzsüz ve hacimli fön görünümü",
    intro:
      "Günlük kullanım ya da özel anlarınız için saçınıza pürüzsüzlük ve hacim kazandıran fön seçeneklerini birlikte planlıyoruz.",
    talkingPoints: [
      {
        title: "İstediğiniz görünüm",
        text: "Pürüzsüz mü yoksa hacimli bir fön mü istediğinizi birlikte belirliyoruz.",
      },
      {
        title: "Saçınızın mevcut durumu",
        text: "Saçınızın dokusu ve uzunluğu üzerinden uygun şekillendirmeyi konuşuyoruz.",
      },
      {
        title: "İçerik ve ücret",
        text: "Fön ve şekillendirme kapsamını, güncel ücret bilgisini salondan netleştiriyoruz.",
      },
    ],
  },
  {
    id: "keratin-kalici-duzlestirme",
    slug: "keratin-kalici-duzlestirme",
    name: "Keratin — Kalıcı Düzleştirme",
    category: "sac",
    short: "Daha pürüzsüz ve bakımlı bir görünüm için keratin uygulaması.",
    imageFile: "GY-G1-08-keratin.jpg",
    // Gerçek fotoğraf eklendiğinde buraya bağlanacak.
    image:
      "https://readdy.ai/api/search-image?query=Sleek%20smooth%20straightened%20hair%20with%20a%20healthy%20glossy%20finish%20after%20a%20keratin%20smoothing%20treatment%2C%20elegant%20and%20soft%20styling%2C%20warm%20ivory%20and%20champagne%20palette%2C%20soft%20diffused%20light%2C%20premium%20hair%20salon%20editorial%20photography%2C%20clean%20minimal%20warm%20background%2C%20high%20detail&width=900&height=1125&seq=gulayonar-hizmet-keratin&orientation=portrait",
    alt: "Keratin uygulaması sonrası pürüzsüz ve parlak saç görünümü",
    intro:
      "Keratin — kalıcı düzleştirme uygulamasında saçınızda daha pürüzsüz ve bakımlı bir görünüm hedefini birlikte değerlendiriyoruz.",
    talkingPoints: [
      {
        title: "Hedeflediğiniz görünüm",
        text: "Ne kadar pürüzsüz ve düz bir görünüm istediğinizi birlikte belirliyoruz.",
      },
      {
        title: "Saçınızın mevcut durumu",
        text: "Saç yapınız ve daha önceki işlemler üzerinden uygun yaklaşımı konuşuyoruz.",
      },
      {
        title: "İçerik ve ücret",
        text: "Uygulamanın kapsamını ve güncel ücret bilgisini salondan netleştiriyoruz.",
      },
    ],
  },
  {
    id: "keratin-botox",
    slug: "keratin-botox",
    name: "Keratin Botox",
    category: "sac",
    short: "Düzleştirirken saçın bakımını da hedefleyen uygulama.",
    imageFile: "GY-G1-09-keratin-botox.jpg",
    // Gerçek fotoğraf eklendiğinde buraya bağlanacak.
    image:
      "https://readdy.ai/api/search-image?query=Treated%20hair%20looking%20smooth%20replenished%20and%20shiny%20after%20a%20hair%20botox%20application%2C%20soft%20elegant%20styling%20with%20healthy%20texture%2C%20warm%20ivory%20and%20champagne%20palette%2C%20soft%20diffused%20light%2C%20premium%20hair%20salon%20editorial%20photography%2C%20clean%20minimal%20warm%20background%2C%20high%20detail&width=900&height=1125&seq=gulayonar-hizmet-keratin-botox&orientation=portrait",
    alt: "Keratin botox uygulaması sonrası bakımlı ve parlak saç görünümü",
    intro:
      "Keratin botox uygulamasında saçınızı düzleştirirken aynı zamanda bakımını da hedefleyen bir yaklaşımı birlikte konuşuyoruz.",
    talkingPoints: [
      {
        title: "İstediğiniz sonuç",
        text: "Saçınızda daha pürüzsüz ve bakımlı bir görünüm hedefinizi birlikte belirliyoruz.",
      },
      {
        title: "Saçınızın mevcut durumu",
        text: "Saçınızın ihtiyacı ve mevcut durumu üzerinden uygun yaklaşımı değerlendiriyoruz.",
      },
      {
        title: "İçerik ve ücret",
        text: "Uygulamanın kapsamını ve güncel ücret bilgisini salondan netleştiriyoruz.",
      },
    ],
  },
  {
    id: "mikro-kaynak",
    slug: "mikro-kaynak",
    name: "Mikro Kaynak",
    category: "sac",
    short: "Doğal görünümlü, nokta nokta uygulanan saç kaynağı.",
    imageFile: "GY-G1-10-mikro-kaynak.jpg",
    // Gerçek fotoğraf eklendiğinde buraya bağlanacak.
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20natural%20looking%20micro%20keratin%20hair%20extensions%20being%20applied%20strand%20by%20strand%20with%20precision%2C%20detailed%20hands%20and%20soft%20hair%20texture%2C%20warm%20ivory%20and%20champagne%20palette%2C%20soft%20diffused%20light%2C%20premium%20hair%20salon%20editorial%20photography%2C%20clean%20minimal%20warm%20background%2C%20high%20detail&width=900&height=1125&seq=gulayonar-hizmet-mikro-kaynak&orientation=portrait",
    alt: "Mikro kaynak uygulaması yapılan doğal görünümlü saç",
    intro:
      "Mikro kaynak uygulamasında doğal görünümlü bir sonuç için saçınızın yapısına ve istediğiniz uzunluğa uygun yaklaşımı birlikte planlıyoruz.",
    talkingPoints: [
      {
        title: "İstediğiniz uzunluk ve yoğunluk",
        text: "Saçınıza hangi uzunluk ve yoğunlukta katkı istediğinizi birlikte belirliyoruz.",
      },
      {
        title: "Saçınızın mevcut durumu",
        text: "Saçınızın mevcut durumu üzerinden size uygun uygulamayı değerlendiriyoruz.",
      },
      {
        title: "İçerik ve ücret",
        text: "Uygulamanın kapsamını ve güncel ücret bilgisini salondan netleştiriyoruz.",
      },
    ],
  },
  {
    id: "orgu",
    slug: "orgu",
    name: "Örgü",
    category: "sac",
    short: "Günlük stilden özel gün tasarımlarına örgü modelleri.",
    imageFile: "GY-G1-11-orgu.jpg",
    // Gerçek fotoğraf eklendiğinde buraya bağlanacak.
    image:
      "https://readdy.ai/api/search-image?query=Intricate%20braided%20hairstyle%20detail%20on%20a%20model%2C%20elegant%20and%20modern%20braid%20design%2C%20soft%20loose%20strands%2C%20warm%20ivory%20and%20champagne%20gold%20palette%2C%20soft%20diffused%20studio%20light%2C%20premium%20hair%20salon%20editorial%20photography%2C%20clean%20minimal%20warm%20background%2C%20high%20detail&width=900&height=1125&seq=gulayonar-hizmet-orgu&orientation=portrait",
    alt: "Örgü modeliyle şekillendirilmiş saç tasarımı",
    intro:
      "Günlük stilinizden özel gün tasarımlarınıza kadar örgü modellerini birlikte planlıyor, size uygun dokunuşu seçiyoruz.",
    talkingPoints: [
      {
        title: "İstediğiniz örgü modeli",
        text: "Hayalinizdeki örgü modelini ve görünümü birlikte belirliyoruz.",
      },
      {
        title: "Saçınızın mevcut durumu",
        text: "Saçınızın uzunluğu ve yoğunluğu üzerinden uygun modeli konuşuyoruz.",
      },
      {
        title: "İçerik ve ücret",
        text: "Uygulamanın kapsamını ve güncel ücret bilgisini salondan netleştiriyoruz.",
      },
    ],
  },

  // ——— GELİN & ÖZEL GÜN ———
  {
    id: "gelin-saci-zarif-topuz",
    slug: "gelin-saci-zarif-topuz",
    name: "Gelin Saçı — Zarif Topuz",
    category: "gelin",
    short: "Duvak ve saç aksesuarıyla tamamlanan topuz örneği.",
    imageFile: "GY-G2-01-gelin-topuzu.jpg",
    image:
      "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/14329d38-8576-4029-9405-cde3e03e6103_compressed_res2.webp",
    alt: "Duvak ve kristal aksesuarla tamamlanmış zarif gelin topuzu",
    intro:
      "Duvak ve saç aksesuarıyla tamamlanan zarif bir topuzla, özel gününüzde sade ve şık bir görünüm hedefliyoruz.",
    talkingPoints: [
      {
        title: "İstediğiniz gelin görünümü",
        text: "Hayalinizdeki topuz modelini, duvak ve aksesuar tercihlerinizi birlikte konuşuyoruz.",
      },
      {
        title: "Saçınızın mevcut durumu",
        text: "Saç uzunluğu ve yoğunluğu üzerinden size en uygun topuz seçeneklerini belirliyoruz.",
      },
      {
        title: "Hazırlık süreci ve ücret",
        text: "Gelin hazırlığı kapsamını ve güncel ücret bilgisini salondan netleştiriyoruz.",
      },
    ],
  },
  {
    id: "gelin-saci-hacimli-topuz",
    slug: "gelin-saci-hacimli-topuz",
    name: "Gelin Saçı — Hacimli Topuz",
    category: "gelin",
    short: "Özel gününüz için hacimli topuz örneği.",
    imageFile: "GY-G2-02-hacimli-topuz.jpg",
    image:
      "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/e2e3c7dd-603b-49ea-a67d-552a9a9e6f57_compressed_res10.webp",
    alt: "Işıltılı örgü detaylı hacimli gelin topuzu",
    intro:
      "Özel gününüz için hacimli ve romantik bir topuzla, göz alıcı ama zarif bir görünüm planlıyoruz.",
    talkingPoints: [
      {
        title: "İstediğiniz hacim ve form",
        text: "Ne kadar hacimli ve hangi formda bir topuz istediğinizi birlikte belirliyoruz.",
      },
      {
        title: "Saçınızın mevcut durumu",
        text: "Saç uzunluğu ve yoğunluğuna göre hacim oluşturma seçeneklerini konuşuyoruz.",
      },
      {
        title: "İçerik ve ücret",
        text: "Hacimli topuz hazırlığının kapsamını ve güncel ücreti salondan netleştiriyoruz.",
      },
    ],
  },
  {
    id: "gelin-hazirligi",
    slug: "gelin-hazirligi",
    name: "Gelin Hazırlığı",
    category: "gelin",
    short: "Gelin saçı ve özel gün hazırlığınızı birlikte planlayalım.",
    imageFile: "GY-G2-04-gelin-hazirligi.jpg",
    // Gerçek fotoğraf eklendiğinde buraya bağlanacak.
    image:
      "https://readdy.ai/api/search-image?query=Bride%20to%20be%20seated%20in%20a%20warm%20ivory%20salon%20suite%20during%20bridal%20styling%2C%20delicate%20veil%20and%20soft%20updo%2C%20champagne%20gold%20accents%2C%20calm%20editorial%20atmosphere%2C%20soft%20diffused%20natural%20light%2C%20premium%20beauty%20salon%20editorial%20photography%2C%20clean%20minimal%20warm%20background%2C%20high%20detail&width=900&height=1125&seq=gulayonar-hizmet-gelin-hazirligi&orientation=portrait",
    alt: "Gelin hazırlığı sırasında saç ve stil planlaması",
    intro:
      "Gelin hazırlığında saçınızı, stilinizi ve özel gün görünümünüzü birlikte planlıyor, size özel bir hazırlık süreci kurguluyoruz.",
    talkingPoints: [
      {
        title: "Hayalinizdeki gelin görünümü",
        text: "Özel gününüz için hayal ettiğiniz saç ve stil görünümünü birlikte netleştiriyoruz.",
      },
      {
        title: "Saçınızın mevcut durumu",
        text: "Saçınızın uzunluğu ve yoğunluğu üzerinden uygun hazırlık adımlarını konuşuyoruz.",
      },
      {
        title: "Hazırlık kapsamı ve ücret",
        text: "Gelin hazırlığı kapsamını ve güncel ücret bilgisini salondan netleştiriyoruz.",
      },
    ],
  },
  {
    id: "topuz-ozel-gun-saci",
    slug: "topuz-ozel-gun-saci",
    name: "Topuz & Özel Gün Saçı",
    category: "gelin",
    short: "Davetleriniz için zarif ve size özel topuz modelleri.",
    imageFile: "GY-G2-05-topuz.jpg",
    // Gerçek fotoğraf eklendiğinde buraya bağlanacak.
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20updo%20hairstyle%20on%20a%20model%20with%20soft%20loose%20strands%2C%20refined%20special%20occasion%20styling%2C%20warm%20ivory%20and%20champagne%20gold%20palette%2C%20soft%20diffused%20studio%20light%2C%20premium%20hair%20salon%20editorial%20photography%2C%20clean%20minimal%20warm%20background%2C%20high%20detail&width=900&height=1125&seq=gulayonar-hizmet-topuz&orientation=portrait",
    alt: "Özel gün için zarif topuz modeli",
    intro:
      "Davet ve özel günleriniz için zarif topuz modellerini birlikte seçiyor, yüz hatlarınıza uygun formu planlıyoruz.",
    talkingPoints: [
      {
        title: "İstediğiniz topuz modeli",
        text: "Hayalinizdeki topuz formunu ve görünümünü birlikte belirliyoruz.",
      },
      {
        title: "Saçınızın mevcut durumu",
        text: "Saçınızın uzunluğu ve yoğunluğu üzerinden uygun modeli konuşuyoruz.",
      },
      {
        title: "İçerik ve ücret",
        text: "Uygulamanın kapsamını ve güncel ücret bilgisini salondan netleştiriyoruz.",
      },
    ],
  },
  {
    id: "ozel-gun-makyaji-turban",
    slug: "ozel-gun-makyaji-turban",
    name: "Özel Gün Makyajı ve Türban",
    category: "gelin",
    short: "Makyaj ve türban tasarımından bir uygulama örneği.",
    imageFile: "GY-G2-03-makyaj-turban.jpg",
    // Gerçek fotoğraf eklendiğinde buraya bağlanacak.
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20woman%20with%20refined%20special%20occasion%20makeup%20and%20a%20beautifully%20wrapped%20silk%20turban%20headpiece%20in%20soft%20neutral%20tones%2C%20graceful%20bridal%20and%20celebration%20styling%2C%20warm%20ivory%20and%20champagne%20palette%2C%20soft%20diffused%20natural%20light%2C%20premium%20salon%20editorial%20photography%2C%20clean%20minimal%20warm%20background%2C%20high%20detail&width=900&height=1125&seq=gulayonar-hizmet-07&orientation=portrait",
    alt: "Özel gün makyajı ve türban tasarımı uygulaması",
    intro:
      "Özel günleriniz için makyaj ve türban tasarımını birlikte planlıyor, davet ve kutlamalarınıza uygun zarif bir görünüm hedefliyoruz.",
    talkingPoints: [
      {
        title: "İstediğiniz genel görünüm",
        text: "Makyaj ve türban için hayal ettiğiniz tarzı ve tonları birlikte belirliyoruz.",
      },
      {
        title: "Etkinliğiniz ve tercihleriniz",
        text: "Katılacağınız etkinlik ve kişisel tercihleriniz üzerinden uygun seçenekleri konuşuyoruz.",
      },
      {
        title: "İçerik ve ücret",
        text: "Makyaj ve türban uygulamasının kapsamını ve güncel ücreti salondan netleştiriyoruz.",
      },
    ],
  },

  // ——— GÜZELLİK & BAKIM ———
  {
    id: "altin-oran-kas-tasarimi",
    slug: "altin-oran-kas-tasarimi",
    name: "Altın Oran Kaş Tasarımı",
    category: "bakim",
    short: "Yüz hatlarınıza göre kaş şeklinizi birlikte belirleyelim.",
    imageFile: "GY-G3-01-kas-tasarimi.jpg",
    // Gerçek fotoğraf eklendiğinde buraya bağlanacak.
    image:
      "https://readdy.ai/api/search-image?query=Close-up%20beauty%20portrait%20of%20a%20woman%20with%20perfectly%20shaped%20and%20defined%20eyebrows%20highlighting%20her%20facial%20features%2C%20flawless%20natural%20makeup%2C%20warm%20ivory%20and%20champagne%20palette%2C%20soft%20diffused%20studio%20light%2C%20premium%20beauty%20salon%20editorial%20photography%2C%20clean%20minimal%20warm%20background%2C%20high%20detail&width=900&height=1125&seq=gulayonar-hizmet-08&orientation=portrait",
    alt: "Yüz hatlarına göre belirlenmiş kaş tasarımı",
    intro:
      "Yüz hatlarınıza göre kaş şeklinizi birlikte belirliyor, yüzünüzü dengeleyen doğal ve şık bir görünüm hedefliyoruz.",
    talkingPoints: [
      {
        title: "İstediğiniz kaş formu",
        text: "Kaşlarınızın nasıl bir şekilde ve yoğunlukta olmasını istediğinizi birlikte konuşuyoruz.",
      },
      {
        title: "Mevcut kaş yapınız",
        text: "Kaşlarınızın mevcut durumu üzerinden size uygun tasarımı belirliyoruz.",
      },
      {
        title: "İçerik ve ücret",
        text: "Kaş tasarımının kapsamını ve güncel ücret bilgisini salondan netleştiriyoruz.",
      },
    ],
  },
  {
    id: "hydrafacial-cilt-bakimi",
    slug: "hydrafacial-cilt-bakimi",
    name: "HydraFacial Cilt Bakımı",
    category: "bakim",
    short: "Cilt bakımının içeriği ve size uygun seçenekler için bilgi alın.",
    imageFile: "GY-G3-02-cilt-bakimi.jpg",
    // Gerçek fotoğraf eklendiğinde buraya bağlanacak.
    image:
      "https://readdy.ai/api/search-image?query=Woman%20receiving%20a%20relaxing%20professional%20facial%20skincare%20treatment%20with%20gentle%20cleansing%20and%20hydrating%20mask%2C%20calm%20spa-like%20atmosphere%2C%20warm%20ivory%20and%20champagne%20palette%2C%20soft%20diffused%20ambient%20light%2C%20premium%20beauty%20salon%20editorial%20photography%2C%20clean%20minimal%20warm%20background%2C%20high%20detail&width=900&height=1125&seq=gulayonar-hizmet-09&orientation=portrait",
    alt: "HydraFacial cilt bakımı uygulaması",
    intro:
      "Cilt bakımının içeriği ve size uygun seçenekler için bilgi alın. Cildinizin ihtiyacına göre en doğru yaklaşımı birlikte değerlendiriyoruz.",
    talkingPoints: [
      {
        title: "Cildinizin ihtiyacı",
        text: "Cildinizin mevcut durumunu ve öne çıkarmak istediğiniz konuları birlikte konuşuyoruz.",
      },
      {
        title: "Uygun bakım seçenekleri",
        text: "Size uygun olabilecek bakım seçeneklerini ve içeriklerini salondan değerlendiriyoruz.",
      },
      {
        title: "İçerik ve ücret",
        text: "Cilt bakımının kapsamını ve güncel ücret bilgisini salondan netleştiriyoruz.",
      },
    ],
  },
  {
    id: "g5-masaji",
    slug: "g5-masaji",
    name: "G5 Masajı",
    category: "bakim",
    short: "Bölgesel bakım seçenekleri ve seans bilgisi için bize ulaşın.",
    imageFile: "GY-G3-03-g5.jpg",
    // Gerçek G5 uygulama fotoğrafı kullanılıyor.
    image:
      "https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/c6d29b7f7b77703bd9f2461e99d3b940.png",
    alt: "G5 cihazı ile bölgesel bakım uygulaması",
    intro:
      "Bölgesel bakım seçenekleri ve seans bilgisi için bize ulaşın. İhtiyacınıza uygun yaklaşımı birlikte konuşuyoruz.",
    talkingPoints: [
      {
        title: "Hedeflediğiniz bölgeler",
        text: "Hangi bölgelere odaklanmak istediğinizi birlikte belirliyoruz.",
      },
      {
        title: "Bölgesel bakım seçenekleri",
        text: "Size uygun bölgesel bakım seçeneklerini ve seans bilgisini salondan değerlendiriyoruz.",
      },
      {
        title: "İçerik ve ücret",
        text: "G5 masajının kapsamını ve güncel ücret bilgisini salondan netleştiriyoruz.",
      },
    ],
  },
];

export function getServiceBySlug(slug: string): Service | undefined {
  return services.find((s) => s.slug === slug);
}

export function getRelatedServices(service: Service, limit = 3): Service[] {
  const sameCategory = services.filter((s) => s.id !== service.id && s.category === service.category);
  const others = services.filter((s) => s.id !== service.id && s.category !== service.category);
  return [...sameCategory, ...others].slice(0, limit);
}